import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import { RowIconComponent, ColIconComponent } from '@kuiper/icons';

export interface TableSize {
  rows: number;
  cols: number;
}

@Component({
  selector: 'lib-table-grid-selector',
  templateUrl: './table-grid-selector.component.html',
  styleUrl: './table-grid-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RowIconComponent, ColIconComponent],
})
export class TableGridSelectorComponent {
  maxRows = input(7);
  maxCols = input(7);

  tableSize = output<TableSize>();

  hoveredRow = signal(0);
  hoveredCol = signal(0);

  rows = computed(() =>
    Array.from({ length: this.maxRows() }, (_, i) => i + 1)
  );
  cols = computed(() =>
    Array.from({ length: this.maxCols() }, (_, i) => i + 1)
  );

  highlightedCells = computed(() => {
    const cells = new Set<string>();
    const hRow = this.hoveredRow();
    const hCol = this.hoveredCol();
    for (let r = 1; r <= hRow; r++) {
      for (let c = 1; c <= hCol; c++) {
        cells.add(`${r}-${c}`);
      }
    }
    return cells;
  });

  onCellHover(row: number, col: number): void {
    this.hoveredRow.set(row);
    this.hoveredCol.set(col);
  }

  onCellLeave(): void {
    this.hoveredRow.set(0);
    this.hoveredCol.set(0);
  }

  selectSize(row: number, col: number): void {
    this.tableSize.emit({ rows: row, cols: col });
  }
}
